import React from 'react';
import CustomInput from '../CustomInput/CustomInput';

const Search = ({
  search, ref, text, handleSearch, className, ...rest
}) => {
  const label = '¿Que estas buscando?';
  return (
    <>
      <CustomInput
        {...rest}
        labelText={text || label}
        id="serach"
        value={search}
        // ref={ref}
        formControlProps={{
          fullWidth: true,
          className,
        }}
        inputProps={{
          onChange: handleSearch,
          autoComplete: 'off',
        }}
      />
    </>
  );
};

export default Search;
